export const CARDS = [
  {
    source: "INDIA",
    destination: "LONDON",
    date: "09 Mar 2022",
    arrival_time: "09:15 AM",
    departure_time: "12:15 PM",
    qr_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/QR_code_for_mobile_English_Wikipedia.svg/1920px-QR_code_for_mobile_English_Wikipedia.svg.png",
    meta: [
      { title: "flight", subtitle: "6X545" },
      { title: "seat no", subtitle: "24E" },
      { title: "gate", subtitle: "G" },
      { title: "pnr", subtitle: "ABC123" },
    ],
  },
  {
    source: "INDIA",
    destination: "LONDON",
    date: "09 Mar 2022",
    arrival_time: "09:15 AM",
    departure_time: "12:15 PM",
    qr_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/QR_code_for_mobile_English_Wikipedia.svg/1920px-QR_code_for_mobile_English_Wikipedia.svg.png",
    meta: [
      { title: "flight", subtitle: "6X545" },
      { title: "seat no", subtitle: "24E" },
      { title: "gate", subtitle: "G" },
      { title: "pnr", subtitle: "ABC123" },
    ],
  },
  {
    source: "INDIA",
    destination: "LONDON",
    date: "09 Mar 2022",
    arrival_time: "09:15 AM",
    departure_time: "12:15 PM",
    qr_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/QR_code_for_mobile_English_Wikipedia.svg/1920px-QR_code_for_mobile_English_Wikipedia.svg.png",
    meta: [
      { title: "flight", subtitle: "6X545" },
      { title: "seat no", subtitle: "24E" },
      { title: "gate", subtitle: "G" },
      { title: "pnr", subtitle: "ABC123" },
    ],
  },
  {
    source: "INDIA",
    destination: "LONDON",
    date: "09 Mar 2022",
    arrival_time: "09:15 AM",
    departure_time: "12:15 PM",
    qr_url:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/QR_code_for_mobile_English_Wikipedia.svg/1920px-QR_code_for_mobile_English_Wikipedia.svg.png",
    meta: [
      { title: "flight", subtitle: "6X545" },
      { title: "seat no", subtitle: "24E" },
      { title: "gate", subtitle: "G" },
      { title: "pnr", subtitle: "ABC123" },
    ],
  },
];
